module.exports = __webpack_public_path__ + "eac3be655ab90e2687600c505ec8fd3c.png";